<template>
  <div>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">Payment Reports</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li class="breadcrumb-item active">Payment Reports</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="row justify-content">
          <div class="col-sm-4" style="margin-top: -18px !important">
            <label class="boldText" style="margin-bottom: 0px !important"
              >Users</label
            >
            <div>
              <MultiSelect
                style="width: 400px"
                v-model="selectedUsers"
                :options="usersList"
                optionLabel="name"
                placeholder="Select User"
                display="chip"
                mode="tags"
              />
            </div>
          </div>
         <!-- 
          <div class="col-sm-4" style="margin-top: -18px !important">
            <label class="boldText" style="margin-bottom: 0px !important"
              >Practices</label
            >
            <div>
              <Multiselect
                v-model="selectedPractice"
                placeholder="Select Users"
                :searchable="true"
                :createTag="true"
                :options="practices"
              />
            </div>
          </div> -->

          <div class="col-sm-4">
            <input
              style="margin-bottom: 6px; margin-left: 51px"
              type="text"
              name="daterangePR"
              :value="initDatePR"
              @change="datePickerPR"
              @focus="datePickerPR"
            />
            <div class="input-group-append">
              <span
                class="input-group-text"
                style="
                  position: absolute;
                  margin-top: -34px;
                  margin-left: 230px;
                "
              >
                <span class="ti-calendar"></span>
              </span>
            </div>
          </div>
        </div>
        <p></p>

    <div class="card p-3">
          <div class="table-responsive">
            <div
              class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
            >
              <div class="dataTables_length">
                <span style="margin-right: 10px"
                  ><label for="">Show </label>
                </span>
                <select
                  v-model="pageSize"
                  class="form-control form-control-sm"
                  aria-label="Default select example"
                  @change="pageChange(1)"
                >
                  <option selected>50</option>
                  <option value="100">100</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                  <option value="2000">2000</option>
                </select>

                <span style="margin-left: 10px">
                  <label for=""> Entries </label></span
                >
              </div>
              <!-- <div class="dataTables_filter">
                <span class="float-right">
                  <span style="margin-right: 10px"
                    ><label for="Search">Search:</label></span
                  >
                  <input
                    type="text"
                    @change="SearchDataTable()"
                    v-model="searchFilter"
                    name=""
                    id=""
                  />
                </span>
              </div> -->
            </div>
            <table
              class="
                table
                display
                table-bordered
                text-center
                table-striped
                no-wrap
              "
              id="home_2"
            >
              <thead class="thead-dark">
                <tr>
                  <th style="text-align: start">
                    PTID<span>
                      <button class="asc-desc-btn" @click="orderBy(0)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    Full Name<span>
                      <button class="asc-desc-btn" @click="orderBy(1)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    Category<span>
                      <button class="asc-desc-btn" @click="orderBy(2)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    Reasons<span>
                      <button class="asc-desc-btn" @click="orderBy(3)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                     <th style="text-align: start">
                    DOS<span>
                      <button class="asc-desc-btn" @click="orderBy(4)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                     <th style="text-align: start">
                    Date Collected<span>
                      <button class="asc-desc-btn" @click="orderBy(5)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    Method<span>
                      <button class="asc-desc-btn" @click="orderBy(6)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    Amount Collected<span>
                      <button class="asc-desc-btn" @click="orderBy(7)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    Comments<span>
                      <button class="asc-desc-btn" @click="orderBy(8)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr v-if="payments.length == 0">
                  <td align="center" colspan="100">
                    <strong> No data available</strong>
                  </td>
                </tr>
                <tr v-for="(pay, ndx) in payments" :key="ndx">
                  <td>{{ pay.ptid }}</td>
                  <td>{{ pay.name }}</td>
                  <td>{{ pay.visitType }}</td>
                  <td>{{ pay.visitReason }}</td>
                  <td>{{ pay.dosStr }}</td>
                  <td>{{ pay.paymentDateStr }}</td>
                  <td>{{ pay.paymentMethodName }}</td>
                  <td>${{ pay.amount }}</td>
                  <td>{{ pay.commentText }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--show pagination-->
          <nav aria-label="Page navigation" style="float: right">
            <span
              style="padding-left: 40px"
              v-if="totalRows < pageSize * pageNumber"
              >showing {{ totalRows }} of {{ totalRows }} records</span
            >
            <span style="padding-left: 40px" v-else
              >showing {{ pageSize * pageNumber }} of
              {{ totalRows }} records</span
            >
            <ul class="pagination" style="float: right">
              <li class="page-item colorActive">
                <span v-if="pageNumber == 1">
                  <button
                    disabled
                    class="page-link disabledColor"
                    @click="pageChange('Previous')"
                  >
                    Previous
                  </button>
                </span>
                <span v-else>
                  <button class="page-link" @click="pageChange('Previous')">
                    Previous
                  </button>
                </span>
              </li>
              <!--show pagination-->
              <li v-if="showPagesMin > 1">
                <button class="page-link" @click="pageChange(1)">
                  1
                </button>
              </li>
              <li v-if="showPagesMin > 1">
                <button disabled class="page-link disabledColor">
                  ...
                </button>
              </li>
              <!--show pagination-->
              <li
                v-for="pageNum in totalPages"
                :key="pageNum"
                class="page-item colorActive"
              >
                <span v-if="pageNum >= showPagesMin && pageNum <= showPagesMax">
                  <span v-if="pageNumber == pageNum"
                    ><button
                      class="page-link activeColor"
                      disabled
                      @click="pageChange(pageNum)"
                    >
                      {{ pageNum }}
                    </button>
                  </span>
                  <span v-else>
                    <button class="page-link" @click="pageChange(pageNum)">
                      {{ pageNum }}
                    </button></span
                  >
                </span>
              </li>

              <!--show pagination-->
              <li v-if="totalPages > 10 && totalPages - 4 >= pageNumber">
                <button disabled class="page-link disabledColor">
                  ...
                </button>
              </li>
              <li v-if="totalPages > 10 && totalPages - 4 >= pageNumber">
                <button class="page-link" @click="pageChange(totalPages)">
                  {{ totalPages }}
                </button>
              </li>
              <!--show pagination-->
              <li class="page-item colorActive">
                <span v-if="pageNumber == totalPages">
                  <button
                    disabled
                    class="page-link disabledColor"
                    @click="pageChange('Next')"
                  >
                    Next
                  </button>
                </span>
                <span v-else>
                  <button class="page-link" @click="pageChange('Next')">
                    Next
                  </button>
                </span>
              </li>
            </ul>
          </nav>
        </div>
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
// import Multiselect from "@vueform/multiselect";
//import Swal from "sweetalert2";

export default {
  name: "PaymentReport",
  components: {
    // Multiselect,
  },

  data() {
    return {
      //Data table Stage
      pageNumber: 1,
      pageSize: 50,
      totalPages: 0,
      totalRows: 0,

      //show pagination
      showPagesMin: 1,
      showPagesMax: 5,
      sortColumn: 0,
      sortColumnOption: 0,

      payments: [],
      users: [],
      practices: [],

      usersList: [],
      selectedUsers: [],
      selectedPractice: "",

      startDatePR: "",
      endDatePR: "",
      initDatePR: "",
      dummyDate: moment(String(new Date())).format("YYYY-MM-DD"),
    };
  }, // data

  methods: {
    datePickerPR() {
      const self = this;
      $('input[name="daterangePR"]').daterangepicker(
        {
          opens: "left",
        },
        function (start, end) {
          self.startDatePR = new Date(start);
          self.endDatePR = new Date(end);
          self.initDatePR =
            self.dateToMDY(self.startDatePR) +
            " - " +
            self.dateToMDY(self.endDatePR);
        }
      );
    },
 //code for Data-Tables_
  pageChange(obj) {
    if (obj == "Next") {
      if (this.pageNumber < this.totalPages) {
        this.pageNumber += 1;
      }
    } else if (obj == "Previous" && this.pageNumber != 1) {
      this.pageNumber -= 1;
    } else {
      this.pageNumber = obj;
    }
    //show pagination
    if((this.showPagesMax/2) < (this.pageNumber))
    {
      this.showPagesMin = this.pageNumber-4;
      this.showPagesMax = this.pageNumber+4;
    }
    else if((this.showPagesMin/2)<(this.pageNumber))
    {
      this.showPagesMin = this.pageNumber-4;
      this.showPagesMax = this.pageNumber+4 ;
      if(this.showPagesMax<5)
      {
        this.showPagesMax = 5;
      }
    }
    else{
      this.showPagesMin = 1;
      this.showPagesMax = 5 ;
    }
     //show pagination
    this.fetchInitData();
  },
  orderBy(column) {
    if (this.sortColumn == column) {
      switch (this.sortColumnOption) {
        case 0:
          this.sortColumnOption = 1;
          break;
        case 1:
          this.sortColumnOption = 2;
          break;
        case 2:
          this.sortColumn = 0;
          this.sortColumnOption = 0;
          break;
      }
    } else {
      this.sortColumn = column;
      this.sortColumnOption = 1;
    }
    this.pageNumber = 1;
    this.fetchInitData();
  },
    loadInit() {
      const dd = new Date();
      dd.setDate(dd.getDate() - 30);

      this.startDatePR = new Date();
      this.endDatePR = new Date();
      this.initDatePR =
        this.dateToMDY(this.endDatePR) +
        " - " +
        this.dateToMDY(this.endDatePR);

      this.fetchInitData();
    },

    fetchInitData() {
      this.intDummyComm();
      if (this.selectedUsers.length > 0) {
        let aa = [];
        for (let i = 0; i < this.selectedUsers.length; i++)
          aa.push(this.selectedUsers[i].id);
        this.dummyComm.extras = aa.toString();
        //alert(this.selectedUsers.toString() + "    "+this.dummyComm.extras)
      } else this.dummyComm.extras = "";

      if (this.selectedPractice + "".length > 0) {
        this.dummyComm.extras1 = this.selectedPractice;
      } else this.dummyComm.extras1 = "";

      if (this.initDatePR.length > 0) {
        this.dummyComm.myDate = this.dateToSqlServerDateFormat(
          this.startDatePR
        );
        this.dummyComm.myTime = this.dateToSqlServerDateFormat(this.endDatePR);
      } else {
        this.dummyComm.myDate = null;
        this.dummyComm.myTime = null;
      }

            this.dummyComm.pageNumber = this.pageNumber;
            this.dummyComm.pageSize = this.pageSize;
            this.dummyComm.filter = "";
            
            const filter = {
                veinsId: "",
                externalId: "",
                firstName: "",
                lastName: "",
                phone: "",
                startDate: "",
                endDate: ""
              };
        
            const myData = {
              dc: this.dummyComm,
              filter: filter,
              sortColumn: this.sortColumn,
              sortColumnOption: this.sortColumnOption,
            };

      const url = this.SERVER + "/VNSPRAAPI/Reports/PaymentReportInitData";
      this.axiosGetData(url, 1, myData);
    },

    //------------------------------------------ Common Methods
    async axiosGetData(myUrl, what, myData) {
      var loader = this.$loading.show({
              // Optional parameters
                color: '#03a9f3'
              });
      await axios({
        method: "post",
        url: myUrl,
        data: myData,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          // if everything goes well -- we will get data
          this.lastErrorCode = 1;
          if (what === 1) {
            loader.hide();
            this.totalRows = res.data.dc.totalRow;
            this.totalPages = res.data.dc.totalPages;
            this.users = res.data.users;
            this.practices = res.data.practices;
            this.payments = res.data.payments;
          }
        })
        .catch(function (error) {
          if (error.response) {
            this.lastErrorCode = 1;
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            this.lastErrorCode = 1;
            alert("Error", error.message);
          }
        })
        .finally(() => {loader.hide();});
    }, // axiosGetData
  }, // methods
  computed: {}, // computed

  watch: {
    initDatePR: function () {
      this.fetchInitData();
    },

    selectedUsers: function () {
      this.fetchInitData();
    },

    selectedPractice: function () {
      this.fetchInitData();
    },

    users: function (val) {
      this.usersList = [];
      for (let i = 0; i < val.length; i++) {
        this.usersList.push(val[i]);
      }
    },

    payments: function (val) {
      for (let i = 0; i < val.length; i++) {
        this.payments[i].dosStr = this.dateToLocalString(this.payments[i].dos);
        this.payments[i].paymentDateStr = this.dateToLocalString(
          this.payments[i].paymentDate
        );
      }
    },
  }, //watch

  mounted() {
    this.loadInit();
  }, // mounted
};
</script>

<style scoped>
@import "/node_modules/vue-select-sides/styles/themes/light.scss";
.ms-container {
  background: transparent
    url("https://github.com/lou/multi-select/blob/master/img/switch.png?raw=true")
    no-repeat 50% 50%;
  /* background: transparent url('../img/switch.png') no-repeat 50% 50%; */
  width: 370px;
}
.ms-container:after {
  content: ".";
  display: block;
  height: 0;
  line-height: 0;
  font-size: 0;
  clear: both;
  min-height: 0;
  visibility: hidden;
}

.ms-container .ms-selectable,
.ms-container .ms-selection {
  background: #fff;
  color: #555555;
  float: left;
  width: 45%;
}

.ms-container .ms-selection {
  float: right;
}

.ms-container .ms-list {
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border linear 0.2s, box-shadow linear 0.2s;
  -moz-transition: border linear 0.2s, box-shadow linear 0.2s;
  -ms-transition: border linear 0.2s, box-shadow linear 0.2s;
  -o-transition: border linear 0.2s, box-shadow linear 0.2s;
  transition: border linear 0.2s, box-shadow linear 0.2s;
  border: 1px solid #ccc;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  position: relative;
  height: 200px;
  padding: 0;
  overflow-y: auto;
}

.ms-container .ms-list.ms-focus {
  border-color: rgba(82, 168, 236, 0.8);
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(82, 168, 236, 0.6);
  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(82, 168, 236, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(82, 168, 236, 0.6);
  outline: 0;
  outline: thin dotted \9;
}

.ms-container ul {
  margin: 0;
  list-style-type: none;
  padding: 0;
}

.ms-container .ms-optgroup-container {
  width: 100%;
}

.ms-container .ms-optgroup-label {
  margin: 0;
  padding: 5px 0px 0px 5px;
  cursor: pointer;
  color: #999;
}

.ms-container .ms-selectable li.ms-elem-selectable,
.ms-container .ms-selection li.ms-elem-selection {
  border-bottom: 1px #eee solid;
  padding: 2px 10px;
  color: #555;
  font-size: 14px;
}

.ms-container .ms-selectable li.ms-hover,
.ms-container .ms-selection li.ms-hover {
  cursor: pointer;
  color: #fff;
  text-decoration: none;
  background-color: #08c;
}

.ms-container .ms-selectable li.disabled,
.ms-container .ms-selection li.disabled {
  background-color: #eee;
  color: #aaa;
  cursor: text;
}
.asc-desc-btn {
  background-color: transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline: none;
  color: honeydew;
  float: right;
}
.colorActive {
  color: #f95c2e;
}
.activeColor {
  background-color: #fb9678;
  color: white;
}
</style>